import {useNavigate} from "react-router";
import {useUserAuth} from "../context/UserAuthContext";
import {Button, Container, Row} from "react-bootstrap";
import NavigationBar from "./NavigationBar";
import TempoDashboard from "./TempoDashboard";

const Home = () => {
    const {logOut, user} = useUserAuth();
    const navigate = useNavigate();
    const handleLogout = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            console.log(error.message);
        }
    };

    return (
        <>
            <NavigationBar />
            <Container>
                <Row>
                    <TempoDashboard/>
                </Row>
            </Container>
        </>
    );
};

export default Home;